<template>

    <div v-if="error" :class="error.status === 401 ? 'content_401': 'content_default'">
        <span v-if = "error.status === 401" class="title_code">{{error.status}}</span>
        <span v-if = "error.data.title" class="subtitle">{{ error.data.title}}</span>
        <span class="error_message">{{ error.data.error}}</span>
        <span class="link" v-if="error.status === 409" style="padding-top:20px" v-html="error.data.link"> </span>
    </div>

</template>

<script>
    export default {
        name: "Unauthorized",
        props: {
            error: {},

        },
    }
</script>

<style scoped>
    .link >>> a {
        color: white;
    }
    .link >>> a:hover {
        color: white;
    }

    .content_401 {
        text-align: center;
        display: flex;
        flex-direction: column;
        color: #FFF;
        height: 100%;
        background: #785447;
        padding-top: 150px;
    }

    .content_default {
        text-align: center;
        display: flex;
        flex-direction: column;
        color: #FFF;
        height: 100%;
        background: #747856;
        padding-top: 150px;

    }

    .title_code {
        font-size: 50px;
    }

    .subtitle {
        font-size: 30px;
        padding-top: 30px;
    }

    .error_message {
        font-size: 20px;
        padding-top: 30px;
    }
</style>